export default __webpack_public_path__ + "static/media/ACF-logo.e1e72fe4.svg";